import { jsx as _jsx } from "react/jsx-runtime";
import { twMerge } from 'tailwind-merge';
const __DEFAULT_ELEMENT__ = 'h1';
function Heading({ as, children, className, variant, ...otherProps }) {
    const Tag = as || __DEFAULT_ELEMENT__;
    return (_jsx(Tag, { ...otherProps, className: twMerge('text-text-headers', variant === 'ex-lg' && `type-expressive-lg`, variant === 'ex-md' && `type-expressive-md`, variant === 'ex-sm' && `type-feature-body`, variant === 'lg' && `type-title-lg`, variant === 'md' && `type-title-md`, variant === 'sm' && `type-title-sm`, className), children: children }));
}
export default Heading;
